module.exports = __webpack_public_path__ + "static/media/expat_3.e5f18e00.webp";